import SignUp from "@components/SignUp.jsx";
import { Route, Routes, Navigate } from "react-router-dom";
import SignIn from "@components/SignIn.jsx";
import AuthPage from "@/screens/AuthPage.jsx";
import ProtectedRoute from "@components/ProtectedRoute.jsx";
import ActiveUserRoute from "@components/ActiveUserRoute.jsx";
import VerifyEmailPage from "@/screens/VerifyEmailPage.jsx";
import DashBoardPage from "@/screens/DashBoardPage.jsx";
import Layout from "./components/Layout.jsx";
import AppPage from "@/screens/AppPage.jsx";
import CreateApp from "@components/CreateApp.jsx";
import ProtectedAdminRoute from "@components/AdminPanel/ProtectedAdminRoute.jsx";
import UsersPage from "@/screens/AdminPanel/UsersPage.jsx";
import Apps from "@components/AdminPanel/Apps.jsx";

import OrderASOPage from "@/screens/OrderASOPage.jsx";
import OrdersPage from "@/screens/OrdersPage.jsx";
import FAQPage from "@/screens/FAQPage.jsx";
import ContactsPage from "@/screens/ContactsPage.jsx";
import Orders from "@components/AdminPanel/Orders.jsx";
import InventoryPage from "@/screens/InventoryPage.jsx";
import OrderASOEdit from "@/screens/AdminPanel/PaymentCalendarEdit.jsx";
import FaqEdit from "@/screens/AdminPanel/FaqEdit.jsx";
import ContactEdit from "@/screens/AdminPanel/Contact.jsx";
import ResetPassword from "./components/ResetPassword.jsx";
import PrivacyPolicyPage from "@/screens/PrivacyPolicyPage.jsx";


function App() {
  return (
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route
        path="/auth/sign-up"
        element={
          <AuthPage>
            <SignUp />
          </AuthPage>
        }
      />
      <Route
        path="/auth/sign-in"
        element={
          <AuthPage>
            <SignIn />
          </AuthPage>
        }
      />
      <Route
        path="/auth/reset"
        element={
          <AuthPage>
            <ResetPassword />
          </AuthPage>
        }
      />

      <Route element={<ProtectedRoute />}>
        <Route path="/verify-email" element={<VerifyEmailPage />} />
      </Route>

      <Route element={<ActiveUserRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="app" replace />} />
          <Route path="app" element={<AppPage />} />
          <Route path="dashboard" element={<DashBoardPage />} />
          <Route path="create-app" element={<CreateApp />} />
          <Route path="order-aso" element={<OrderASOPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="faq" element={<FAQPage />} />
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="inventory" element={<InventoryPage />} />
        </Route>
      </Route>

      <Route element={<ProtectedAdminRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="admin" replace />} />
          <Route path="admin" element={<UsersPage />} />
          <Route path="apps" element={<Apps />} />
          <Route path="orders-panel" element={<Orders />} />
          <Route path="order-aso-edit" element={<OrderASOEdit />} />
          <Route path="faq-edit" element={<FaqEdit />} />
          <Route path="contact-edit" element={<ContactEdit />} />
        </Route>
      </Route>
     
    </Routes>
  );
}

export default App;
